import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const hideOn = ["/", "/login", "/dashboard"];
  if (hideOn.includes(location.pathname)) return null;

  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="ml-8 mt-3 inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-white/20 bg-white dark:bg-white/5 dark:border-neutral-700 dark:text-white">
      ← Back
    </button>
  );
}
